import $ = require("jquery");
import WebMap = require("ags-webmap");
import ol = require("ol");
import MapView = require("../views/MapView");
import Utils = require("../utils");
import Portal = require("portal-gis");
import FeatureServer = require("./ags-featureserver");
import Templates = require("../models/defaults");
import Symbology = require("../utils/symbology");
import Converter = require("../utils/ags/style-converter");

let styleConverter = new Converter();

class Handler {

    static about = `
Similar to [ags-discovery](#app/layer-factory/ags-discovery), creates a group layer containing all discovered layers from an agsonline webmap.

Usage Example:

    <Maplet about="https://infor1.maps.arcgis.com/sharing/rest/content/items/313b7327133f4802affee46893b4bec7/data?f=json" id="WebMap-313b7327133f4802affee46893b4bec7" parentId="base" text="Greenville I85 Corridor">
    <MAP>
        <LAYERS>
        <LAYER about="Reads a webmap configuration" id="313b7327133f4802affee46893b4bec7" text="I85 Corridor Features" type="app/layer-factory/ags-webmap" url="//infor1.maps.arcgis.com/sharing/rest/content/items/313b7327133f4802affee46893b4bec7/data?f=json">
            <OPTIONS>
            <Values about="Import all operational layers" id="operationalLayers" value="true" />
            <Values about="Import basemap layers" id="baseMap" value="true" />
            <Values about="import bookmarks" id="bookmarks" value="true" />
            </OPTIONS>
        </LAYER>
        </LAYERS>
        <SYMBOLOGY>
        <SYMBOL about="Features from a webmap configuration" id="webmap" label="WebMap Item">
            <ICON about="WebMap items are all black and white" id="*" label="&lt;%= TITLE %&gt;" style="{&#xD;&#xA;    &quot;type&quot;: &quot;mixed&quot;,&#xD;&#xA;    &quot;fill&quot;: {&#xD;&#xA;        &quot;style&quot;: &quot;solid&quot;,&#xD;&#xA;        &quot;color&quot;: [0, 0, 0, 0.5]&#xD;&#xA;    },&#xD;&#xA;    &quot;outline&quot;: {&#xD;&#xA;        &quot;style&quot;: &quot;solid&quot;,&#xD;&#xA;        &quot;color&quot;: [255, 255, 255, 1],&#xD;&#xA;        &quot;width&quot;: 1&#xD;&#xA;    },&#xD;&#xA;    &quot;text&quot;: {&#xD;&#xA;        &quot;font&quot;: &quot;20px courier new&quot;,&#xD;&#xA;        &quot;textAlign&quot;: &quot;center&quot;&#xD;&#xA;    }&#xD;&#xA;}" type="style" />
            <ICON about="WebMap type 2 Point" id="point" label="&lt;%= TITLE %&gt;" style="{&quot;type&quot;:&quot;circle&quot;,&quot;radius&quot;:7,&quot;fill&quot;:{&quot;color&quot;:[247,96,84]}}" type="style">
            <FILTERS>
                <FILTER about="Stride is a numeric value so need the '=' to do a == instead of an ===" id="geometryType" value="Point" />
            </FILTERS>
            </ICON>
        </SYMBOL>
        </SYMBOLOGY>
        <VIEWPORT about="Greenville" extent="-82.3,34.8,-82.1,35" />
        <OPTIONS>
        <Values id="default-interactions" value="{&#xD;&#xA;    &quot;altShiftDragRotate&quot;: true,&#xD;&#xA;    &quot;doubleClickZoom&quot;: true,&#xD;&#xA;    &quot;keyboard&quot;: true,&#xD;&#xA;    &quot;mouseWheelZoom&quot;: false,&#xD;&#xA;    &quot;shiftDragZoom&quot;: true,&#xD;&#xA;    &quot;dragPan&quot;: true,&#xD;&#xA;    &quot;pinchRotate&quot;: true,&#xD;&#xA;    &quot;pinchZoom&quot;: true,&#xD;&#xA;    &quot;zoomDuration&quot;: 1&#xD;&#xA;}" />
        <Values id="default-controls" value="{&#xD;&#xA;    &quot;attribution&quot;: false,&#xD;&#xA;    &quot;rotate&quot;: false,&#xD;&#xA;    &quot;zoom&quot;: true&#xD;&#xA;}" />
        <Values about="To be moved to VIEWPORT" id="min-zoom" value="5" />
        <Values about="To be moved to VIEWPORT" id="max-zoom" value="20" />
        <Values about="To be moved to VIEWPORT" id="init-zoom" value="9" />
        <Values about="To be moved to VIEWPORT" id="init-center" value="-82.3,34.8,-82.1,35" />
        </OPTIONS>
    </MAP>
    </Maplet>


    `;

    static options = {
        "layerType": {
            "about": "Service type to query (only queries webmap services).",
            "domain": "webmap",
            "default": "webmap"
        }
    }

    /**
     * Similar to ags-discovery, creates a group layer containing all discovered layers
     * but this handler should have no external dependencies...put all the logic here for clarity (see ags-featureserver)
     */
    private static webmap(l: Portal.MapLayerLeaf, view: MapView) {

        var options = Utils.asDictionary(l.Options.Values);

        let group = new ol.layer.Group({
            id: l.id,
            title: l.text,
            visible: "false" !== options["visible"]
        });

        let url = l.url;

        $.ajax(url, {
            type: "GET",
            dataType: "text"
        }).then(response => {
            let webmap = <WebMap.WebMap>JSON.parse(response);
            if (webmap.operationalLayers) {
                webmap.operationalLayers.forEach(l => {

                    if (l.featureCollection) {
                        let source = new ol.source.Vector();
                        let opLayer = new ol.layer.Vector({
                            source: source,
                            visible: true
                        });

                        let addFeature = (f: WebMap.Feature, geom: ol.geom.Geometry, displayFieldName: string, symbology = options["symbology"] || "webmap") => {
                            let feature = new ol.Feature({
                                symbology: symbology,
                                name: f.attributes[displayFieldName],
                                geometry: geom
                            });
                            feature.setProperties(<any>f.attributes);

                            if (f.symbol) {
                                let symbol = styleConverter.asIcon(f.symbol, {});
                                let style = Symbology.asStyle(symbol);
                                feature.setStyle(style);
                            }

                            source.addFeature(feature);
                        };

                        view.mediator.mapViewMap(map => {
                            opLayer.setStyle((feature: ol.Feature, resolution: number) => {
                                let attributes = feature.getProperties();
                                attributes["zoom"] = map.getView().getZoom() + "";
                                attributes["geometryType"] = feature.getGeometry().getType();
                                let style = Symbology.findStyle(view.mediator, {
                                    attributes: attributes
                                });
                                return style;
                            });
                        });

                        l.featureCollection.layers.forEach((l, i) => {
                            let displayFieldName = l.layerDefinition.displayField || l.layerDefinition.fields[0].name;

                            let symbols = styleConverter.asSymbology(l.layerDefinition.drawingInfo, { url: null });
                            let symbology = l.id + "symbol-hack" + i;
                            symbols.Symbols[0].id = symbology;
                            view.mediator.api.symbology.add(symbols.Symbols[0]);

                            switch (l.featureSet.geometryType) {
                                case "esriGeometryMultiPoint":
                                    l.featureSet.features.forEach(f => addFeature(f, new ol.geom.MultiPoint(f.geometry.points), displayFieldName, symbology));
                                    break;
                                case "esriGeometryPoint":
                                    l.featureSet.features.forEach(f => addFeature(f, new ol.geom.Point([f.geometry.x, f.geometry.y]), displayFieldName, symbology));
                                    break;
                                case "esriGeometryPolyline":
                                    l.featureSet.features.forEach(f => addFeature(f, new ol.geom.MultiLineString(f.geometry.paths), displayFieldName, symbology));
                                    break;
                                case "esriGeometryPolygon":
                                    l.featureSet.features.forEach(f => addFeature(f, new ol.geom.Polygon(f.geometry.rings), displayFieldName, symbology));
                                    break;
                                default:
                                    break;
                            }
                        });

                        group.getLayers().push(opLayer);
                    }
                    else {
                        let layerConfig = Templates.asLayerTemplate({
                            id: l.id,
                            text: l.title,
                            url: l.url,
                            type: "featureserver",
                            basemap: false
                        });
                        layerConfig.Options.Values.push({
                            id: "symbology",
                            value: options["symbology"] || "webmap"
                        });

                        let opLayer = FeatureServer.create({
                            view: view,
                            layer: layerConfig
                        });
                        group.getLayers().push(opLayer);
                    }
                });
            }
        });

        return group;
    }

    static create(args: { layer: Portal.MapLayerLeaf; view: MapView }): ol.layer.Layer {
        var l = args.layer;
        var options = Utils.asDictionary(l.Options.Values);
        var layerType = options["layerType"] || "webmap";
        var factory = Handler.webmap;
        factory = Handler[layerType] || factory;
        return factory && factory(l, args.view);
    }

}

export = Handler;
